import React from "react";
import styled from "styled-components/macro";
import { Spin } from "antd";

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
`;

const Spinner = () => (
  <Container>
    <Spin />
  </Container>
);

export default Spinner;
